var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": "推荐简历",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    key: _vm.preventKey + 'a',
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), (_vm.isSingle) ? _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("当前职位：" + _vm._s(_vm.confirmInfo.position))])])], 1) : _c('el-table', {
    attrs: {
      "data": _vm.multiConfirmInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "prop": "resumeForm.name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_GENDER', scope.row.resumeForm.gender) || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "prop": "resumeForm.mobilePhone",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮箱",
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前职位",
      "prop": "positionForm.name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "recommend-wrap border-radius"
  }, [_c('el-tabs', {
    staticClass: "recommend-tabs",
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.ruleForm.noticeType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "noticeType", $$v)
      },
      expression: "ruleForm.noticeType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "邮件",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "POPO推送",
      "name": "0"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    key: _vm.preventKey + 'b',
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "推荐职位",
      "prop": _vm.isSingle ? 'positionId' : ''
    }
  }, [_c('transfer-select', {
    attrs: {
      "positionList": _vm.positionList
    },
    model: {
      value: (_vm.ruleForm.positionId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionId", $$v)
      },
      expression: "ruleForm.positionId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评估人",
      "prop": "evaluator"
    }
  }, [_c('user-search', {
    ref: "evaluator",
    model: {
      value: (_vm.ruleForm.evaluator),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "evaluator", $$v)
      },
      expression: "ruleForm.evaluator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.noticeType === '1'),
      expression: "ruleForm.noticeType === '1'"
    }],
    attrs: {
      "label": "抄送人",
      "prop": "ccs"
    }
  }, [_c('user-search', {
    ref: "ccs",
    model: {
      value: (_vm.ruleForm.ccList),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ccList", $$v)
      },
      expression: "ruleForm.ccList"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐说明",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "reason", $$v)
      },
      expression: "ruleForm.reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("发送" + _vm._s(_vm.ruleForm.noticeType === '1' ? '邮件' : 'POPO消息'))])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9874b1da"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/recommendResumeDialog.vue
// module id = null
// module chunks = 